import ZenDeskClient from 'utils/ZenDeskClient'

// Naive check for now, this will allow us create something more robust when we need.
// We should be able to check the query / search params as a better indicator, Zendesk always set them.
const isInZendeskSidebar = (): boolean => Boolean(ZenDeskClient)

export default isInZendeskSidebar
